import React, {useCallback, useMemo} from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import Dropdown from './../Dropdown/Dropdown';
import {HeaderIcon, Warning} from './../styles';

import { routes } from "#app/constants/routes";

const SCENARIO_NAME = 'register';
const TEACHER_ICON_PATH = require('../../../../assets/icons/teacher.svg');
const TEACHER_RED_ICON_PATH = require('../../../../assets/icons/teacher_red.svg');
const DEFAULT_HEADER_COLOR = '#95DCFB';
const TRAINING_HEADER_COLOR = '#F8BFC6';

const TeachDropdown = ({
                         demo,
                         tutorial,
                         finishScenario,
                         handleEndDemo,
                         handleEndTutorial,
                         startScenario,
                         auth // Предполагается, что auth где-то есть (из пропсов или контекста)
                       }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Показывает, включён ли демонстрационный/обучающий режим
  const isTrainingMode = demo || tutorial;

  // Колбэк, который будет вызван после завершения сценария
  const finishScenarioCallback = useCallback(() => {
    handleEndDemo();
    handleEndTutorial();

    // Если авторизован и уже не на той же странице - переходим на нужный URL
    const currentPath = location.pathname + location.search;
    if (auth && currentPath !== routes.TRAINING_PAGE_URL) {
      navigate(routes.TRAINING_PAGE_URL);
    }
  }, [handleEndDemo, handleEndTutorial, auth, location.pathname, location.search, navigate]);

  // Обработчик завершения обучения
  const handleFinishScenario = useCallback(
    (e) => {
      e.preventDefault();
      finishScenario({
        scenario: SCENARIO_NAME,
        callback: finishScenarioCallback
      });
    },
    [finishScenario, finishScenarioCallback]
  );

  // Обработчик начала обучения
  const handleStartScenario = useCallback(
    (e) => {
      e.preventDefault();
      startScenario({
        scenario: SCENARIO_NAME,
        callback: () => {}
      });
    },
    [startScenario]
  );

  // Массив ссылок в режиме обучения
  const trainingLinks = useMemo(
    () => [
      {
        id: 'demo-menu-0',
        link: '/cabinet/demo',
        text: 'Завершить обучение',
        onClick: handleFinishScenario
      }
    ],
    [handleFinishScenario]
  );

  // Массив ссылок в обычном режиме
  const defaultLinks = useMemo(
    () => [
      { id: 'demo-menu-3', link: '/cabinet/quizes', text: 'Опросы' },
      {
        id: 'demo-menu-2',
        link: '/cabinet/tutorial',
        text: 'Обучение',
        onClick: handleStartScenario
      }
    ],
    [handleStartScenario]
  );

  // Выбираем нужный массив ссылок в зависимости от режима
  const links = isTrainingMode ? trainingLinks : defaultLinks;

  // Цвет фона и иконка для хэдера
  const headerColor = isTrainingMode ? TRAINING_HEADER_COLOR : DEFAULT_HEADER_COLOR;
  const iconSrc = isTrainingMode ? TEACHER_RED_ICON_PATH : TEACHER_ICON_PATH;

  return (
    <Dropdown id="teach-header-content" links={links}>
      <HeaderIcon id="teach-icon" style={{ backgroundColor: headerColor }}>
        <Warning src={iconSrc} alt="teacher-icon" />
      </HeaderIcon>
    </Dropdown>
  );
};

export default TeachDropdown;